<template>
  <div>
    <base-modal :show="showModal" @close="handleClose" @save="saveEdit">
      <template v-slot:header> Order Email </template>
      <template v-slot:main>
        <div>
          <base-label>Email</base-label>
          <base-input v-model="emailData.email" />
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from "@/components/ui/elements/BaseModal";
export default {
  name: "ChangeOrderEmail",
  components: { BaseModal },
  props: ["showModal", "emailData"],
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    saveEdit() {
      this.$notify({
        title: "Order",
        message: "Saving...",
        type: "success",
      });
      this.$store.dispatch("order/edit_email", this.emailData).then((resp) => {
        if (!resp.success) return;

        this.$notify({
          title: "Order",
          message: "This email has been changed",
          type: "success",
        });
        this.$emit("saved");
      });
    },
  },
  computed: {},
  mounted() {},
};
</script>

<style scoped></style>
